<template>
  <div class="flex border-mid-gray border rounded-xl p-4 justify-between">
    <div>
      <div v-if="!isPassFailChallenge" class="text-medium line-clamp-1">
        {{ formattedHistoryValue }} {{ placeholder }}
      </div>
      <div v-else-if="isPassFailChallenge" class="text-medium line-clamp-1">
        <span v-if="historyEntry.value === 1">{{
          $t("custom.challenge.track.yes.no.yes.button.caption")
        }}</span>
        <span
          v-else-if="historyEntry.value === 0 && historyEntry.id !== null"
          >{{ $t("custom.challenge.track.yes.no.no.button.caption") }}</span
        >
        <span v-else>-</span>
      </div>
      <div class="text-small">
        {{ DateTime.fromISO(historyEntry.date).toFormat("dd.MM.yyyy") }}
      </div>
    </div>
    <button
      v-if="isValueEditable()"
      class="text-sm border border-light-gray rounded-full px-4 py-1 transition"
      @click="open = true"
    >
      {{ $t("challenge.statistic.edit.button.label") }}
    </button>
  </div>
  <EditHistoryModal
    v-if="open"
    :id="id"
    :open="open"
    :placeholder="placeholder"
    :date="historyEntry.date"
    :hint="hint"
    :limit="limit"
    :initial-value="historyValue"
    :is-pass-fail-challenge="isPassFailChallenge"
    :is-competitive-challenge="isCompetitiveChallenge"
    :progress-value-type="progressValueType"
    @close="open = false"
    @update-history="handleUpdateHistory"
  />
</template>
<script setup lang="ts">
import { HistoryEntryDto } from "../../../dto/history-entry.dto.ts";
import { DateTime } from "luxon";
import EditHistoryModal from "./EditHistoryModal.vue";
import { formatChallengeProgressValue } from "../../../plugins/NumberFormat";
import type { ProgressValueType } from "../../../enum/v2/progress-value-type";
const open = ref(false);
const emit = defineEmits(["update-history"]);

const props = defineProps({
  historyEntry: {
    type: Object as PropType<HistoryEntryDto>,
    required: true,
  },
  placeholder: {
    type: String,
  },
  isTeamChallenge: {
    type: Boolean,
  },
  isPassFailChallenge: {
    type: Boolean,
  },
  hint: {
    type: String,
  },
  id: {
    type: [Number, String],
  },
  endDate: {
    type: String,
  },
  limit: {
    type: Number,
  },
  isCompetitiveChallenge: {
    type: Boolean,
    default: false,
  },
  progressValueType: {
    type: String as PropType<ProgressValueType>,
  },
});

const historyValue = ref(props.historyEntry.value);
const formattedHistoryValue = computed(() => {
  if (!props.progressValueType) {
    return historyValue.value;
  }

  return formatChallengeProgressValue(
    historyValue.value,
    props.progressValueType,
    { roundUp: true }
  );
});

function isValueEditable() {
  const daysToEditAfterEndDate = 3;
  const finalEndDate = DateTime.fromISO(props.endDate).plus({
    days: daysToEditAfterEndDate,
  });

  return finalEndDate.toMillis() > DateTime.now().toMillis();
}

function handleUpdateHistory(newProgress) {
  historyValue.value = newProgress;
  emit("update-history", newProgress);
}
</script>
